
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaioutstatuscabs() {



    const cardData =
    {
        keyword: 'Mumbai Outstation Cabs',
        heading: 'Vedant Travels: Mumbai Outstation Cabs',
        headingDescription: 'Vedant Travels offers affordable and reliable outstation cab services from Mumbai to various destinations across Maharashtra and beyond. Whether you are planning a spiritual pilgrimage, a family vacation, a business trip, or a weekend getaway, our fleet of well-maintained sedans, SUVs, and luxury cars ensures a comfortable journey. Our experienced drivers prioritize safety and punctuality, making your travel stress-free.',

        top: 'Top Places to Visit in Akkalkot with Vedant Travels',

"topPlaces": [
    {
        "title": "Mumbai to Pune Cab",
        "description": "The distance between Mumbai and Pune is 150 km, and the travel time is approximately 3 to 4 hours. Pune, the 'Oxford of the East,' is a blend of history, culture, and modernity. Visit the Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati Temple, and the scenic Sinhagad Fort."
    },
    {
        "title": "Mumbai to Shirdi Cab",
        "description": "Mumbai to Shirdi covers a distance of 240 km, with a travel time of around 5 to 6 hours. Shirdi, the home of Sai Baba, is one of India's most visited pilgrimage destinations. Key attractions include Shri Sai Baba Temple, Dwarkamai, Chavadi, and Wet N Joy Water Park."
    },
    {
        "title": "Mumbai to Mahabaleshwar Cab",
        "description": "The journey from Mumbai to Mahabaleshwar spans 260 km and takes approximately 6 to 7 hours. Mahabaleshwar is a scenic hill station known for strawberry farms, Pratapgad Fort, Venna Lake, and breathtaking viewpoints like Arthur’s Seat and Elephant’s Head Point."
    },
    {
        "title": "Mumbai to Lonavala & Khandala Cab",
        "description": "The distance between Mumbai and Lonavala is 80 km, with a travel time of about 2 hours. Lonavala and Khandala are famous for their lush green hills, Rajmachi Fort, Bhushi Dam, Tiger’s Leap, and Karla Caves—perfect for a weekend escape."
    },
    {
        "title": "Mumbai to Nashik Cab",
        "description": "Mumbai to Nashik is a 170 km drive that takes approximately 4 to 5 hours. Nashik is known for its temples and vineyards. Visit the Trimbakeshwar Temple, Sula Vineyards, Pandav Leni Caves, and the Godavari River Ghats."
    },
    {
        "title": "Mumbai to Goa Cab",
        "description": "A road trip from Mumbai to Goa covers 580 km and takes about 10 to 12 hours. Goa is an exciting adventure destination known for beaches, nightlife, churches, forts, and water sports at top spots like Baga Beach, Dudhsagar Waterfalls, and Aguada Fort."
    },
    {
        "title": "Mumbai to Aurangabad Cab",
        "description": "The drive from Mumbai to Aurangabad is 330 km, with a travel duration of around 7 to 8 hours. Aurangabad is home to UNESCO World Heritage Sites like Ajanta and Ellora Caves, as well as Bibi Ka Maqbara, Daulatabad Fort, and Grishneshwar Jyotirlinga Temple."
    },
    {
        "title": "Mumbai to Kolhapur Cab",
        "description": "Mumbai to Kolhapur spans 380 km and requires about 7 to 8 hours of travel. Kolhapur is famous for the Mahalaxmi Temple, Rankala Lake, Jyotiba Temple, and Panhala Fort. It is also known for its Kolhapuri footwear and spicy cuisine."
    },
    {
        "title": "Mumbai to Alibaug Cab",
        "description": "The distance from Mumbai to Alibaug is 95 km, with a travel time of around 2 to 3 hours. Alibaug is a perfect beachside getaway with Alibaug Beach, Murud-Janjira Fort, Kashid Beach, and Kolaba Fort. It’s ideal for a one-day or weekend trip."
    },
    {
        "title": "Mumbai to Satara Cab",
        "description": "Mumbai to Satara is a 260 km journey that takes approximately 6 hours. Satara is known for its Kaas Plateau (Valley of Flowers), Sajjangad Fort, Thoseghar Waterfalls, and Ajinkyatara Fort. A great destination for nature lovers!"
    }
],

"services": [
    {
        "name": "Mumbai Outstation Cabs by Vedant Travels",
        "description": "Planning an outstation trip from Mumbai? Vedant Travels offers reliable and comfortable outstation cab services. Whether it's a short weekend getaway or a long-distance journey, our well-maintained vehicles and experienced drivers ensure a smooth and stress-free ride."
    },
    {
        "name": "Mumbai Outstation Taxi",
        "description": "Looking for a taxi for an outstation trip from Mumbai? Vedant Travels provides dependable outstation taxi services with a variety of vehicle options, ensuring you travel in comfort. From business trips to family vacations, we’ve got the right taxi for your needs."
    },
    {
        "name": "Mumbai to Outstation Car Hire",
        "description": "Rent a car for your outstation trip from Mumbai with Vedant Travels. Choose from a range of vehicles, including sedans, SUVs, and more, to suit your travel preferences. Enjoy a flexible and comfortable experience, whether you're going for a short trip or a long journey."
    },
    {
        "name": "Mumbai to Outstation Taxi Booking",
        "description": "Booking an outstation taxi from Mumbai is simple with Vedant Travels. Whether you're traveling to nearby destinations or long-distance spots, we offer flexible booking options that allow you to book online or over the phone for a convenient and hassle-free experience."
    },
    {
        "name": "Outstation Cab Service Mumbai",
        "description": "Vedant Travels offers a comprehensive outstation cab service from Mumbai. Whether you’re traveling solo or with family or friends, we provide well-maintained cabs with professional drivers, ensuring a smooth and pleasant journey to your destination."
    },
    {
        "name": "Mumbai Outstation Cab Fare",
        "description": "At Vedant Travels, we provide transparent and competitive pricing for all outstation trips from Mumbai. Our rates are affordable, with no hidden costs, so you can enjoy a hassle-free ride without worrying about extra charges. Contact us for an accurate fare estimate for your journey."
    },
    {
        "name": "Best Outstation Cabs Mumbai",
        "description": "For the best outstation cab services in Mumbai, choose Vedant Travels. We offer top-notch vehicles and experienced drivers to ensure that your outstation journey is comfortable, safe, and efficient. Travel with us for a reliable and stress-free experience."
    },
    {
        "name": "Mumbai Outstation Car Rental",
        "description": "Rent a car from Mumbai to your outstation destination with Vedant Travels. We provide flexible car rental services with a wide range of vehicles, including sedans and SUVs, to meet your travel needs and ensure you travel in comfort."
    },
    {
        "name": "Mumbai Outstation Innova",
        "description": "For a premium and comfortable ride, choose the Innova for your outstation trip from Mumbai. With spacious seating and luxurious amenities, the Innova is perfect for families or groups traveling to nearby or distant destinations."
    },
    {
        "name": "Mumbai Outstation Ertiga Cab",
        "description": "Traveling with a family or a small group? Book an Ertiga cab for your outstation journey from Mumbai. Spacious, comfortable, and cost-effective, the Ertiga is the perfect vehicle for long-distance travel while ensuring your comfort throughout the trip."
    }
],

"tableData": [
    ["Mumbai Outstation Cabs", "Mumbai Outstation Taxi"],
    ["Mumbai to Outstation Car Hire", "Mumbai to Outstation Taxi Booking"],
    ["Outstation Cab Service Mumbai", "Mumbai Outstation Cab Fare"],
    ["Best Outstation Cabs Mumbai", "Mumbai Outstation Car Rental"],
    ["Mumbai Outstation Innova", "Mumbai Outstation Ertiga Cab"],
    ["", ""]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Whether you're traveling for business, leisure, or religious purposes, we ensure timely pickups and drop-offs, making your outstation journey from Mumbai seamless and stress-free."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a comfortable ride in our spacious, well-maintained vehicles. Designed for long-distance travel, our cars provide ample legroom, air conditioning, and comfortable seating, ensuring a pleasant journey to your outstation destination."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are highly experienced and familiar with the best routes for outstation travel. They ensure a safe, smooth, and efficient ride, with expert knowledge of road conditions and optimal routes."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We offer competitive pricing for outstation cabs with no hidden charges. Vedant Travels ensures transparency in pricing, so you can enjoy a worry-free journey without any surprises in costs."
    },
    {
      "WhyChooseheading": "Safe and Comfortable Journey",
      "WhyChoosedescription": "Safety is our top priority. Our vehicles are regularly serviced and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers strictly follow safety protocols, ensuring a secure journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need a cab for an early morning departure or a late-night return, Vedant Travels is available 24/7 to serve you. Our customer service team is always ready to assist you with bookings or any inquiries."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai outstation cab is easy. You can book online through our website or mobile app, or you can contact our customer service team for assistance. We make the booking process as simple and convenient as possible."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "Whether you're planning a religious trip, business travel, or leisure vacation, we offer customized travel packages for your outstation journey. Let us know your preferences, and we’ll tailor your trip to fit your needs and comfort."
    }
  ]


    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book an outstation cab from Mumbai with Vedant Travels?',
            answer: 'You can easily book your outstation cab online via our website or mobile app. Alternatively, you can call our customer service team to assist you with your booking.',
        },
        {
            id: 2,
            question: 'Are the drivers experienced for outstation travel?',
            answer: 'Yes, our drivers are highly trained and experienced in long-distance and outstation travel, ensuring your journey is safe, smooth, and comfortable.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for Mumbai outstation travel?',
            answer: 'We offer a variety of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are designed for long-distance comfort and equipped for a safe and pleasant journey.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai outstation cab rental?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app for your convenience.',
        },
        {
            id: 5,
            question: 'Can I book a round trip for an outstation journey?',
            answer: 'Yes, we offer round-trip services for your outstation trips. Simply provide your return details when booking, and we’ll ensure a smooth trip back to Mumbai.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours on outstation trips?',
            answer: 'Any additional charges for waiting or detours will be communicated clearly upfront. We value transparency and ensure that you are aware of any extra costs before your trip.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing during my outstation trip?',
            answer: 'Yes, we offer sightseeing services for many popular outstation destinations. Explore attractions along the way or at your destination with a trusted driver who will guide you.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for an outstation cab from Mumbai?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have larger or specialized luggage, please let us know when booking, and we will make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate outstation travel?',
            answer: 'Yes, we offer corporate travel services for business meetings, conferences, and professional trips to various outstation destinations from Mumbai.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai outstation cabs?',
            answer: 'Vedant Travels stands out for its reliable, safe, and comfortable services. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure your outstation trip is smooth, affordable, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rakesh Patel",
            title: "Business Traveler",
            quote: "I booked an outstation cab for a trip from Mumbai to Pune. The journey was smooth and comfortable, and the driver was very professional. I highly recommend Vedant Travels for long-distance trips!",
            rating: 5,
        },
        {
            name: "Mrs. Neelam Agarwal",
            title: "Family Traveler",
            quote: "Our family took an outstation cab to Nashik for a religious visit. The vehicle was clean, spacious, and the driver was friendly and punctual. We had a great experience with Vedant Travels!",
            rating: 5,
        },
    ];
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
 
 const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Outstation Cabs",
  "image": "https://vedanttravels.in/assets/images/mumbai-outstation-cabs.jpg",
  "description": "Book Mumbai outstation cabs with Vedant Travels for safe, comfortable, and affordable travel to nearby cities and tourist destinations. Choose from AC sedans, SUVs, and tempo travellers with professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "4700"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-outstation-cabs"
  }
};



  
   
      


    return (
        <div>
              
  <Helmet>
  <title>Mumbai Outstation Cabs | Affordable & Reliable | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai outstation cabs with Vedant Travels for safe, comfortable, and affordable travel to nearby cities and tourist destinations. Choose from AC sedans, SUVs, and tempo travellers with professional drivers." 
  />
  <meta 
    name="keywords" 
    content="Mumbai Outstation Cabs, Outstation Taxi Mumbai, Mumbai Outstation Cab Booking, Vedant Travels Mumbai, AC Outstation Cab Mumbai, SUV Outstation Taxi Mumbai, Tempo Traveller Mumbai, Affordable Outstation Cab Mumbai, Mumbai to Nearby Cities Cab, Reliable Taxi Service Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/80.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaioutstatuscabs;